const BUY_NOW_SELECTOR = '[data-buy-now-button]';

function resetBuyNowButtons() {
  document.querySelectorAll(`${BUY_NOW_SELECTOR}[aria-busy="true"]`).forEach((button) => {
    button.removeAttribute('aria-busy');
    button.disabled = false;
  });
}

function encodeLineItemProperties(formData) {
  const properties = {};

  for (const [name, value] of formData.entries()) {
    const match = name.match(/^properties\[(.+)]$/);

    if (match && typeof value === 'string' && value !== '') {
      properties[match[1]] = value;
    }
  }

  if (Object.keys(properties).length === 0) {
    return null;
  }

  const bytes = new TextEncoder().encode(JSON.stringify(properties));
  let binary = '';

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return window
    .btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
}

document.addEventListener('click', (event) => {
  const button = event.target.closest(BUY_NOW_SELECTOR);

  if (!button || button.disabled) {
    return;
  }

  event.preventDefault();

  const formId = button.getAttribute('form');
  const productForm = formId ? document.getElementById(formId) : button.closest('form');

  if (!productForm) {
    return;
  }

  if (!productForm.checkValidity()) {
    productForm.reportValidity();
    return;
  }

  const formData = new FormData(productForm);
  const variantId = formData.get('id');
  const parsedQuantity = Number.parseInt(formData.get('quantity') || '1', 10);
  const quantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;

  if (!variantId) {
    return;
  }

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  const rootUrl = window.Shopify?.routes?.root || '/';
  const properties = encodeLineItemProperties(formData);
  const query = properties ? `?properties=${encodeURIComponent(properties)}` : '';
  const checkoutUrl = `${rootUrl}cart/${encodeURIComponent(variantId)}:${quantity}${query}`;

  window.location.assign(checkoutUrl);
});

window.addEventListener('pageshow', resetBuyNowButtons);
